import { Paper, Group, Text } from '@mantine/core';
import { useState } from "react";
import MantineImage from '../../components/mantine/image';
import { useNavigate } from 'react-router-dom';
import ActionMenuBySiteId from '../../pages/drawings/actionMenu';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';


const CategoryBox = ({ data, from, siteId, showActionMenu, drawingitem, getDrawings }: any) => {

  const categoryUrl = `${from}/${data.category}/${siteId}`;
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState<any>([]);
  const detailUrl = `/drawing-detail/${drawingitem?.id}/${drawingitem?.siteId}`;

  const handleItemClick = () => {
    const drawingDetails = getDrawings
      ?.filter((drawing: any) => drawing.categoryId === data.categoryId)
      .map((drawing: any) => ({
        imageUrl: drawing.imageUrl,
        uploadFile: drawing.uploadFile,
      }));

    if (!drawingDetails || drawingDetails.length === 0) {
      setSelectedCategory(drawingitem);
      navigate(categoryUrl);
    } else {
      navigate(detailUrl, { state: { category: drawingitem.categoryName, categoryId: drawingitem.categoryId, images: drawingDetails, files: null } });
    }
  };
  const handleMenuClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };
  return (
    <div
      onClick={handleItemClick} style={{ display: 'flex', width: 212, height: 212, backgroundColor: "#2F7FE2", justifyContent: 'center', alignItems: 'center', flexDirection: 'column', border: '2.5px solid #8BF2FF', borderRadius: '6px', position: 'relative', overflow: 'hidden', textAlign: 'center', cursor: 'pointer' }}
    >
      <Paper style={{ width: 140, height: 140, background: '#4395ED 0% 0% no-repeat padding-box', position: 'absolute', borderRadius: 96, left: -25, top: -25, zIndex: 2 }} />
      <Paper style={{ width: 212, height: 212, background: '#3289E8 0% 0% no-repeat padding-box', position: 'absolute', borderRadius: 96, left: -35, top: -35, zIndex: 1 }} />

      {showActionMenu && (
        <div
          style={{ position: 'absolute', top: 10, right: 10, zIndex: 10 }}
          onClick={handleMenuClick}
        >
          <ActionMenuBySiteId setSelectedCategory={setSelectedCategory} item={drawingitem} />
        </div>
      )}

      <Group style={{ position: 'relative', zIndex: 10, flexDirection: 'column' }}>
        <MantineImage
          src={require(`../../assets/images/${data.category}.svg`)}
          style={{ width: 68 }}
        />
        <Text style={{ color: '#8BF2FF', fontSize: '16px' }}>{data.name}</Text>
      </Group>
    </div>
  );
}

export default CategoryBox;